import React, { Component } from 'react';
import styled from 'styled-components';

import Box from './Box';

export default class Overview extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <MainSection>
          <Text>blueshyft is an Australian-based technology provider which allows customers to make over-the-counter payments for a wide range of online services.</Text>
          <Text>The blueshyft point-of-sale app runs on an easy-to-use iPad and is provided to retailers for free, allowing them to earn commission for every transaction processed through it!</Text>
          <Text>blueshyft aims to transform retailers for the digital age, by positioning news and convenience stores as local brick-and-mortar outlets for major online businesses. Our service is entirely free for retailers, never costing you a cent!</Text>
        </MainSection>
        <Section>
          <Box
            src="/images/redesign/icon-map.png"
            text="Join a growing network of 1400+ active agents around the country."
            width="50px"
          />
          <Box
            src="/images/redesign/icon-gift.png"
            text="Completely free, with no joining or ongoing fees - just revenue!"
            width="50px"
          />
          <Box
            src="/images/redesign/icon-thumbs-up.png"
            text="Built by leading developers, our iPad platform is super easy to use!"
            width="50px"
          />
        </Section>
        <Section>
          <Box
            src="/images/redesign/icon-expand.png"
            text="Continually expanding our diverse range of suppliers and services."
            width="50px"
          />
          <Box
            src="/images/redesign/icon-lock.png"
            text="No lock in contracts - if you’re unhappy you can cancel at any time."
            width="40px"
          />
          <Box
            src="/images/redesign/icon-comission.png"
            text="Earn commission for every transaction completed on the iPad!"
            width="50px"
          />
        </Section>
      </div>
    )
  }
}

const MainSection = styled.div`
  width: 965px;
  height: 300px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: 50px;
  color: #505d68;
  margin-bottom: 25px;
`;

const Section = styled.div`
  width: 965px;
  height: 150px;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  padding-left: 50px;
  padding-right: 50px;
`;

const Text = styled.div`
  font-family: 'Karla', sans-serif;
  font-size: 22px;
  text-align: center;
`;




// WEBPACK FOOTER //
// ./client/redesign/signup/Main/pages/Overview/index.js